import { useState } from 'react';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/Store';
import { IUserList, IUserRoleList } from '../interfaces';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}/vendor`;

export interface IRequestParams {
  name: string;
  role: string;
}

export const useUserList = () => {
  const [data, setData] = useState<IUserList[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const getUserList = async (params?: IRequestParams) => {
    setLoading(true);
    try {
      const res = await axios.get<IUserList[]>(`${VENDOR_MC_URL}/${user?.vendor.id}/user`, { params });
      setData(res.data);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { data, getUserList, loading, error, setError };
};
export const useUserRoleList = () => {
  const [data, setData] = useState<IUserRoleList[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const getUserRoleList = async () => {
    setLoading(true);
    try {
      const res = await axios.get<IUserRoleList[]>(`${VENDOR_MC_URL}/${user?.vendor.id}/user/roles`);
      setData(res.data);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { data, getUserRoleList, loading, error, setError };
};

export const useUserAdd = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const userAdd = async (body: any) => {
    setLoading(true);
    try {
      body.groupId = parseInt(body.groupId);
      var request = { ...body };
      var code = request.phone.split('(')[1].split(')')[0];
      var phone = request.phone.split('(')[1].split(')')[1].split(' ');
      var phoneNumber = '';
      phone.forEach((element: any) => {
        phoneNumber = phoneNumber + element;
      });
      phoneNumber = code + phoneNumber;
      request.phone = phoneNumber;
      const res = await axios.post<any[]>(`${VENDOR_MC_URL}/${user?.vendor.id}/user/create`, request);
      setData(res.data);
    } catch (error: any) {
      switch (error?.response?.data?.errorCode) {
        case 'USER_ALREADY_REGISTERED':
          setError('Kullanıcı zaten kayıtlı');
          break;
        default:
          setError(error?.response?.data?.message);
          break;
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, userAdd, loading, error, setError };
};

export const useUserUpdate = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const userUpdate = async (body: any) => {
    setLoading(true);
    try {
      body.groupId = parseInt(body.groupId);
      var request = { ...body };
      var code = request.phone.split('(')[1].split(')')[0];
      var phone = request.phone.split('(')[1].split(')')[1].split(' ');
      var phoneNumber = '';
      phone.forEach((element: any) => {
        phoneNumber = phoneNumber + element;
      });
      phoneNumber = code + phoneNumber;
      request.phone = phoneNumber;
      const res = await axios.post<any[]>(`${VENDOR_MC_URL}/${user?.vendor.id}/user/update/${request.user_id}`, request);
      setData(res.data);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { data, userUpdate, loading, error, setError };
};

export const useUserDelete = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const userDelete = async (user_id: string) => {
    setLoading(true);
    try {
      const res = await axios.get<any[]>(`${VENDOR_MC_URL}/${user?.vendor.id}/user/delete/${user_id}`);
      setData(res.data);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { data, userDelete, loading, error, setError };
};

export const useUserDeactive = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const userDeactive = async (user_id: string) => {
    setLoading(true);
    try {
      const res = await axios.get<any[]>(`${VENDOR_MC_URL}/${user?.vendor.id}/user/deactive/${user_id}`);
      setData(res.data);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { data, userDeactive, loading, error, setError };
};
export const useUserActive = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const { user } = useAppSelector((state) => state.auth);

  const userActive = async (user_id: string) => {
    setLoading(true);
    try {
      const res = await axios.get<any[]>(`${VENDOR_MC_URL}/${user?.vendor.id}/user/activate/${user_id}`);
      setData(res.data);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return { data, userActive, loading, error, setError };
};
